import { Routes } from "@angular/router";

/** Customer risk detail (standalone screen under app layout). */
export const customerDetailRoutes: Routes = [
  {
    path: "customer-detail",
    loadComponent: () =>
      import("./customer-detail.component").then(
        (m) => m.CustomerDetailComponent,
      ),
  },
  {
    path: "customer-profile",
    loadComponent: () =>
      import("./customer-profile/customer-profile").then(
        (m) => m.CustomerProfile,
      ),
  },
];
